import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const RegisterPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h1 className="text-3xl font-bold mb-6 text-blue-600">Join Our Network of Dental Practices</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-xl mb-6">
              Dental Hero is always looking to partner with new dental practices across the UK to expand our emergency dental care network.
            </p>
            
            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-8">
              <h2 className="text-2xl font-bold mb-4 text-blue-600">Why Partner With Dental Hero?</h2>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Increase your practice revenue with new emergency patients</li>
                <li>Fill empty slots in your schedule</li>
                <li>Simple and straightforward referral process</li>
                <li>No long-term commitments or contracts</li>
                <li>Expand your patient base with potential for recurring patients</li>
              </ul>
            </div>
            
            <h2 className="text-2xl font-bold mt-8 mb-4 text-blue-600">Getting Started Is Easy</h2>
            <p className="mb-6">
              The first step to joining our network is to get in touch with our practice relations team. We'll discuss how our service works, answer any questions you may have, and explain the onboarding process.
            </p>
            
            <div className="bg-blue-600 text-white rounded-lg p-8 text-center mb-8">
              <h3 className="text-2xl font-bold mb-4">Contact Us Today</h3>
              <p className="text-xl mb-4">Call our practice relations team at:</p>
              <a href="tel:07457411865" className="text-3xl font-bold hover:underline block mb-4">
                07457 411 865
              </a>
              <p className="text-lg">We look forward to working with you!</p>
            </div>
            
            <h3 className="text-xl font-bold mt-8 mb-2">What Happens Next?</h3>
            <ol className="list-decimal pl-6 mb-6 space-y-2">
              <li>Initial phone consultation to understand your practice</li>
              <li>Verification of practice credentials and qualifications</li>
              <li>Setup of your practice profile in our system</li>
              <li>Training on our booking and patient referral process</li>
              <li>Start receiving emergency dental patient referrals</li>
            </ol>
            
            <p className="italic text-gray-600 mt-8">
              Note: Dental Hero partners with fully qualified and registered dental practices only. All practices must meet our quality standards and maintain appropriate professional indemnity insurance.
            </p>
          </div>
        </div>
        
        {/* <div className="text-center mt-8">
          <p className="mb-4">Have other questions about working with us?</p>
          <Link to="/consultant-terms" className="text-blue-600 hover:underline">
            View our Consultant Terms
          </Link>
        </div> */}
      </main>
      <Footer />
    </div>
  );
};

export default RegisterPage;
